import { render, staticRenderFns } from "./navigationGF.vue?vue&type=template&id=9fbf8bd0&scoped=true"
import script from "./navigationGF.vue?vue&type=script&lang=js"
export * from "./navigationGF.vue?vue&type=script&lang=js"
import style0 from "./navigationGF.vue?vue&type=style&index=0&id=9fbf8bd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbf8bd0",
  null
  
)

export default component.exports